var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-plus-button"},[_c('c-icon-plus-button',{staticClass:"c-plus-button__icon"}),_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }